<template>
    <div>
        <div class="paste-uploader" ref="pasteBox" @blur="blurInput" @paste="imgPasteHandle" contenteditable="true" placeholder="点击后请将图片粘在此处">
        </div>
    </div>
</template>

<script>
    import { api } from '../common/request'
    import axios from 'axios'
    export default {
      name: 'pasteUpload',
      props: {
        userId: {
            type: String,
            required: true
        },
        value: {
            type: String,
            default: ''
        }  
      },
      data () {
        return {
         
        }
      },
      watch: {
        value: function(val) {
            this.editor.txt.html(val)
        }
      },
      methods: {
        blurInput() {
          this.$refs.pasteBox.innerHTML = ''
        },
        // 粘贴事件
        imgPasteHandle(e) {
          // console.log(e)
          // console.log(e.clipboardData.getData('text'))

          var clipboardData = e.clipboardData || e.originalEvent && e.originalEvent.clipboardData || {};
          var items = clipboardData.items;

          console.log(items);
          if (items.length == 0) {
            this.$message.error('不支持的粘贴!');
            return;
          }
          for(var i = 0; i < items.length; i++) {
            var item = items[i];
            if (i > 0) break;
            // console.log(item)
            
            if (item.kind == "file") {
                var file = item.getAsFile();
                console.log(file)
                if (file.size === 0) {
                    return;
                }
                const isImg = /^image\/*/.test(file.type)
                const isLt5M = file.size / 1024 / 1024 < 5
                if (!isImg) {
                  this.$message.error('请上传图片格式的文件!');
                  return;
                }
                if (!isLt5M) {
                  this.$message.error('上传图片大小不能超过 5MB!');
                  return;
                }
                this.$refs.pasteBox.blur()
                this.uploadFile(file)
            }
          }
        },
        uploadFile(file) {
          let param = new FormData()
          param.append('files', file, file.name)
          param.append('imageType', 12101)
          param.append('imageUserId', this.userId)
          let config = {
            headers: {
              'Content-Type':'multipart/form-data'
            }
          }
          axios.post(api.baseUrl + '/file/uploadfilebatch',param,config).then(res => {
            console.log(res)
            if (res.status == 200) {
              this.$emit('on-success', res.data, file)
            } else {
              this.$message.error('上传图片失败!');
            }
          }).catch(e => {
            console.log(e)
            this.$message.error('上传图片失败!');
          })
        }
      },
      mounted() {
       
      }
    }
</script>

<style lang="scss" scoped>
.paste-uploader {
  width: 88px;
  height: 88px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  outline: none;
  text-align: center;
  font-size: 11px;
  color: #606266;
  box-sizing: border-box;
  padding-top: 28px;
  box-sizing: border-box;
  line-height: 1.5;
  position: relative;
  &:hover {
    border-color: #F81D22;
  }
  &:empty:before{
    content:attr(placeholder);
    position: absolute;
    left: 0;
    top: 0;
    color: #606266;
    font-size: 11px;
    text-align: center;
    width: 100%;
    height: 100%;
    line-height: 1.5;
    padding: 28px 10px 0;
    box-sizing: border-box;

  }
  &:focus:before{
      content:none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pasteUpload.vue